import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
/**
 * スワイパー用のスライドリストを作成して返す
 */
const createSwiperSlides = (itemList) => {
    return itemList.map((fileName) => {
        return (React.createElement(SwiperSlide, { key: fileName },
            React.createElement("img", { src: fileName, className: "w-full" })));
    });
};
const ItemSlider = ({ itemList, onSwiper, onSlideChange }) => {
    return (React.createElement(Swiper, { onSlideChange: onSlideChange, onSwiper: onSwiper }, createSwiperSlides(itemList)));
};
export default ItemSlider;
